<div class="image-wrapper-select comman-wrap">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 no-padding">
        <div class="card mb-3">
          <div *ngFor="let param of data?.parameters">
            <p *ngIf="param.name === 'ISBESTSELLER' && param.value === 'Yes'" class="best-seller d-flex">
              <img src="assets/icon/gold_star.svg" alt="star-icon" />
              <span>BEST SELLER</span>
            </p>
          </div>
          <img class="card-img-top" src="{{data?.images.large[0].url}}"
            (error)="data?.images.large[0].url ='assets/icon/placeholder.svg'" alt="img" />
          <div class="card-body text-desc">
            <div class="veg" *ngFor="let param of data.parameters">
              <p class="img-block">
                <span *ngIf="param.name === 'VEG' && param.value === 'No'">
                  <img src="assets/icon/nonveg.svg" alt="non-veg">
                </span>
                <span *ngIf="param.name === 'VEG' && param.value === 'Yes'">
                  <img src="assets/icon/veg.svg" alt="non-veg">
                </span>
              </p>
            </div>
            <h5 class="card-title">{{ data.name }}</h5>
            <!--diet info :: start-->
            <ng-container *ngFor="let param of data.parameters">
              <ng-container *ngIf="
                param.name === 'CATEGORY' &&
                param.value === 'Drink'">
                <ng-container *ngIf="data.options && data.options['customization']">
                  <div class="diet" *ngFor="
                    let diet of data.options['customization']['modifiersItems'];
                    let i = index">
                    <h5>
                      <ng-container *ngIf="diet.name === 'Size'">
                        <span *ngFor="
                          let item of diet['items'];
                          let j = index">
                          <span *ngIf="diet['defaultItemIds'][0] === item.id">
                            {{ item.name }}({{ item.description }})
                            <span class="dot">.</span>{{ data.dietaryInformation }}
                          </span>
                        </span>
                      </ng-container>
                    </h5>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="
              param.name === 'CATEGORY' &&
              param.value !== 'Drink'">
                <div class="diet">
                  <h5>
                    <span *ngIf="data.dietaryInformation">{{ data.dietaryInformation }}</span>
                  </h5>
                </div>
              </ng-container>
            </ng-container>
            <!--diet info :: end-->
            <div class="ingredients">
              <ng-container *ngIf="data.productIngredientsOptions && data.productIngredientsOptions.dark">
                <div *ngFor="let ig of data.productIngredientsOptions.dark">
                  <img src={{ig.iconUrl}} alt={{ig.alt}} />
                  {{ig.title | uppercase}}
                </div>
              </ng-container>
            </div>
            <p class="card-text">{{ data.description }}</p>
            <div class="card-footer-custom">
              <div class="left-item" *ngIf = "itemPrice">
                <h4>₹ {{itemPrice | priceformat:'integer' }}<span class="round-figure">.{{itemPrice |
                    priceformat:'decimal'}}</span></h4>
              </div>
              <div class="left-item" *ngIf = "!itemPrice">
                <h4>₹ {{data.defaultPrice | priceformat:'integer' }}<span class="round-figure">.{{data.defaultPrice |
                    priceformat:'decimal'}}</span></h4>
              </div>
              <div class="left-item">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container>
    <div class="price-details  radius-10">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-8">
            <div class="item-and-price">
              <div>
                <p>Repeat Last used customization ?</p>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="item-and-price" style="justify-content: flex-end;">
              <div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="add-to-cart">
      <div class="container">
        <div class="row" *ngIf="data.inStock">
          <div class="col-12 text-right" [ngClass]="{'btn-align':isMobile,'shimmer-loader-button': isClicked}">
            <button type="button" class="custom-btn offer-btn btn-lg-rounded"
              (click)="chooseAgain();chooseAgainGA()">I'll Choose Again</button>
            <button type="button" class="custom-btn btn-white btn-sm-rounded" style="box-shadow: none;"
              (click)="getbasketItem()" [ngClass]="{'br animate-button-white' : isClicked}"
              [disabled]="addItemEvent">
              Repeat Last
            </button>
          </div>
        </div>
        <div class="row" *ngIf="!data.inStock">
          <div class="col-12 text-right" [ngClass]="{'btn-align':isMobile,'shimmer-loader-button': isClicked}">
            <button type="button"  [disabled]="!data.inStock" class="custom-btn btn-white btn-sm-rounded" style="box-shadow: none;"
               [ngClass]="{'br animate-button-white' : isClicked}"
              [disabled]="addItemEvent">
              Out of stock
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
